{
    "Timezone_Title_Change": "Wijzig de tijdzone van de gebruiker",
    "Timezone_Title_Update": "Tijdzone van gebruiker bijwerken",
    "Timezone_Dropdown_Title": "Tijdzone",
    "Timezone_Tab_General": "Algemeen",
    "Timeline_Prompt_Change": "Wijziging",
    "Timeline_Prompt_Cancel": "Annuleren",
    "Timeline_Prompt_Change_Message": "We hebben een wijziging gedetecteerd in uw gebruikerstijdzone \n \n Oorspronkelijk was dit **{}** \n \n Wilt u uw lokale tijdzone wijzigen naar **{}**",
    "Timeline_Prompt_First_Time_Message": "Uw huidige rapportagetijdzone is ingesteld op **{}** \n \n Wilt u uw rapporten bijwerken naar uw lokale tijdzone **{}**",
    "NAME": "TimezoneModal"
}